module.exports = __webpack_public_path__ + "static/media/contact15.202f80b8.png";